import { render, staticRenderFns } from "./T1GeoPrzewodnikContent.vue?vue&type=template&id=2258a952&scoped=true&"
import script from "./T1GeoPrzewodnikContent.vue?vue&type=script&lang=js&"
export * from "./T1GeoPrzewodnikContent.vue?vue&type=script&lang=js&"
import style0 from "./T1GeoPrzewodnikContent.vue?vue&type=style&index=0&id=2258a952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258a952",
  null
  
)

export default component.exports